module.exports = ".error {\n  font-size: 26px;\n  color: rgba(0, 0, 0, 0.38);\n  text-align: center;\n  margin: 32px auto;\n  font-weight: 300; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/downloads/download.component.scss
// module id = ./src/app/downloads/download.component.scss
// module chunks = main